import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { ReactComponent as Logo } from '../../wmgr_logo.svg';
import img1 from '../../images/health_wearable.jpg'
import img2 from '../../images/healthcare-landscape.jpg'
import img3 from '../../images/health_vr.jpg'

import {
    Alignment,
    Button,
    Classes,
    H5,
    Navbar,
    NavbarDivider,
    NavbarGroup,
    NavbarHeading,
    Switch,
} from "@blueprintjs/core";


class Footer extends Component {
  render() {
    return (
        <div className="footer">
            <div className="cl-3">
                <Logo/>
                Wellness Matrix Group represents a next generation health and wellness platform aimed at benefiting our customers from a wholistic perspective by providing personalized biometric data analytics along with global industry and health data research to improve quality of life and longevity.
           <h4>More Information</h4>
           <div className="flexer footer_links">
                <div className=""><Link to="/">Home</Link></div>
                <div className=""><Link to="/solutions">Solution</Link></div>
                <div className=""><Link to="/howitworks">How It Works</Link></div>
                <div className=""><Link to="/press">Press</Link></div>
                <div className=""><Link to="/about">About</Link></div>
                <div className=""><Link to="/blog">Blog</Link></div>
                <div className=""><Link to="/contact">Contact</Link></div>
            </div>
            </div> 
            <div className="cl-3">
                <div className="content_text_title">Popular Posts</div>
                Our organization works as a leader in the health industry to research leading trends and has a hybrid review process including diverse experts along with artificial intelligence to gather the best of global information and services to deliver comprehensive and seamless solutions and insights.  Explore some of our recent articles to learn more about the latest advances and possibilities in wholistic health and longevity.

                <div className="article_teaser">
                    <img className="teaser_img" src={img1}/>
                    <Link to="/blog/1" ><h5>Wearables and Smart Watch Health Apps Can Aid Monitoring Wellbeing</h5></Link>
                    <div className="teaser_text">Health monitoring wearables are continuing to improve ranging from activity and sleep tracking to even attitude and mental health insights. Learn about the latest trends...
                    <Link to="/blog/1" className="footer_article_link">
                        <Button className={Classes.MINIMAL}  text="Read Article &raquo;" />
                    </Link>
                    </div>
                </div>
                <div className="article_teaser">
                    <img className="teaser_img" src={img2}/>
                    <Link to="/blog/2" ><h5>Connected Care, The Next Model for Distributed Expert Collaboration</h5></Link>
                    <div className="teaser_text">Technology is enabling geographically dispersed teams and diverse experts to combine intelligence for remote customers.  WMGR is exploring new ways to bring the industry of health and wellness to our customers' fingertips...
                    <Link to="/blog/2" className="footer_article_link">
                        <Button className={Classes.MINIMAL}  text="Read Article &raquo;" />
                    </Link>
                    </div>
                </div>
                <div className="article_teaser">
                    <img className="teaser_img" src={img3}/>
                    <Link to="/blog/5" ><h5>Virtual Reality for Immersive Remote Health Services</h5></Link>
                    <div className="teaser_text">As the VR hardware and software industry continue to grow, WMGR explores how virtual environments can provide rich informational user experiences for our clients, enabling teams of experts to work together in the same space while around the world...
                    <Link to="/blog/5" className="footer_article_link">
                        <Button className={Classes.MINIMAL}  text="Read Article &raquo;" />
                    </Link>
                    </div>
                </div>
            </div>
            <div className="cl-3">
                <div className="content_text_title">Stay In Touch</div>
                We are passionate about connecting with new customers, partners, and other innovators in the health and longevity fields.  Please reach out to us if you are interested in learning more.
                
                <h4></h4>

                <Link to={`/contact`}>

                <Button text="Contact Us" icon="envelope"        intent="primary"/>
                </Link>
                <div>
                    {/*
                <h4>Investor Relations</h4>
                    Michael Selsman: www.publiccommunicationsco.com<br/> 310-553-5732
                    */}
                </div>

               
            </div>
        </div>
    );
  }
}

export default Footer;

/*  <h4>Follow Us</h4>
*/